import { strictLaunchItemRoute } from "@/lib/launchPath";
import { isLaunchLessonId } from "@/lib/launch/launchExperienceRoster";

export interface LaunchProgressionItem {
  itemType: "lesson" | "simulator";
  refId: string;
}

export function getNextBetaPathItemAfterLesson(
  items: readonly LaunchProgressionItem[],
  lessonId: string | undefined | null,
): LaunchProgressionItem | null {
  if (!lessonId) return null;
  const idx = items.findIndex((item) => item.itemType === "lesson" && item.refId === lessonId);
  if (idx < 0) return null;
  return items[idx + 1] ?? null;
}

export function getNextLaunchRouteAfterLesson(
  items: readonly LaunchProgressionItem[],
  lessonId: string | undefined | null,
): string | null {
  const next = getNextBetaPathItemAfterLesson(items, lessonId);
  return next ? strictLaunchItemRoute(next.itemType, next.refId) : null;
}

export function didPassRequiredQuiz(
  correctCount: number,
  totalQuestions: number,
  passRatio = 0.8,
): boolean {
  if (totalQuestions <= 0) return false;
  return correctCount >= Math.ceil(totalQuestions * passRatio);
}

export function shouldBlockRequiredBetaQuiz(params: {
  dataLoaded: boolean;
  lessonId: string | undefined | null;
  lessonName: string;
  questionCount: number;
  quizLoadError: string | null;
  stage: string;
}): boolean {
  return Boolean(
    params.dataLoaded &&
    params.stage === "questions" &&
    params.lessonName &&
    params.lessonId &&
    isLaunchLessonId(params.lessonId) &&
    (params.questionCount === 0 || params.quizLoadError),
  );
}

export function shouldDeferPerQuestionQuizReward(params: {
  accessTier: string | null | undefined;
  lessonId: string | undefined | null;
  isCorrect: boolean;
}): boolean {
  return Boolean(
    params.isCorrect &&
    params.accessTier === "beta" &&
    params.lessonId &&
    isLaunchLessonId(params.lessonId),
  );
}

export function getDeferredBetaQuizReward(params: {
  correctCount: number;
  rewardPerCorrect: number;
  passed: boolean;
}): number {
  if (!params.passed) return 0;
  if (params.correctCount <= 0 || params.rewardPerCorrect <= 0) return 0;
  return params.correctCount * params.rewardPerCorrect;
}
